import { render, staticRenderFns } from "./taxInformation.vue?vue&type=template&id=22a73b91&scoped=true&"
import script from "./taxInformation.vue?vue&type=script&lang=js&"
export * from "./taxInformation.vue?vue&type=script&lang=js&"
import style0 from "./taxInformation.vue?vue&type=style&index=0&id=22a73b91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a73b91",
  null
  
)

export default component.exports